/**
 * How the account delete refuses. The API refuses a delete while an invoice is
 * unpaid or in dispute, with a 409 and `error_code: unpaid_balance`; its own
 * message is written for staff ("voided or written off"), so the owner gets
 * this one.
 */

export const UNPAID_BALANCE = 'unpaid_balance'

export const UNPAID_BALANCE_MESSAGE =
    'Pay your unpaid invoice before you delete the account.'

/**
 * The owner-facing message for a delete (or its preview) the API refused
 * because of an unpaid balance, or null for any other failure.
 *
 * @param {Error & {response?: {data?: {error_code?: string}}}} error
 * @returns {string|null}
 */
export function unpaidBalanceMessage(error) {
    return error?.response?.data?.error_code === UNPAID_BALANCE
        ? UNPAID_BALANCE_MESSAGE
        : null
}
